(function () {
  const STORAGE_KEY = 'genus-cropgroup-filter';

  const genusListEl = document.getElementById('genus-list');
  if (!genusListEl) return;

  const items = Array.from(genusListEl.querySelectorAll('genus-item'));
  if (!items.length) return;

  // Collect unique cropgroups from all genus-items on this letter
  const allCropgroups = new Set();
  items.forEach((item) => {
    const raw = item.dataset.cropgroups || '';
    raw.split(',').forEach((cg) => {
      const trimmed = cg.trim();
      if (trimmed) allCropgroups.add(trimmed);
    });
  });

  const saved = localStorage.getItem(STORAGE_KEY);

  // Include saved filter even if this letter doesn't have it
  const filterCropgroups = new Set([...Array.from(allCropgroups).sort()]);
  if (saved && !filterCropgroups.has(saved)) filterCropgroups.add(saved);

  if (!filterCropgroups.size) return;

  // Build filter UI
  const filterEl = document.createElement('div');
  filterEl.classList.add('genus-filter');

  const clearBtn = document.createElement('button');
  clearBtn.type = 'button';
  clearBtn.classList.add('genus-filter-clear');
  clearBtn.textContent = genusListEl.dataset.clearFilter || 'Filter verwijderen';
  clearBtn.style.display = 'none';
  clearBtn.addEventListener('click', () => clearFilter());

  const noResultsEl = document.createElement('p');
  noResultsEl.classList.add('genus-filter-no-results');
  noResultsEl.textContent = genusListEl.dataset.noResults || 'Geen resultaten';
  noResultsEl.hidden = true;

  let activeFilter = null;

  function applyFilter(cropgroup) {
    activeFilter = cropgroup;
    filterEl.querySelectorAll('.genus-filter-btn').forEach((b) =>
      b.classList.toggle('active', b.dataset.cropgroup === cropgroup)
    );
    let anyVisible = false;
    items.forEach((item) => {
      const groups = (item.dataset.cropgroups || '').split(',').map((s) => s.trim());
      const visible = groups.includes(cropgroup);
      item.toggleAttribute('hidden', !visible);
      if (visible) anyVisible = true;
    });
    noResultsEl.hidden = anyVisible;
    clearBtn.style.display = '';
    localStorage.setItem(STORAGE_KEY, cropgroup);
  }

  function clearFilter() {
    activeFilter = null;
    filterEl.querySelectorAll('.genus-filter-btn').forEach((b) => b.classList.remove('active'));
    items.forEach((item) => item.removeAttribute('hidden'));
    noResultsEl.hidden = true;
    clearBtn.style.display = 'none';
    localStorage.removeItem(STORAGE_KEY);
  }

  Array.from(filterCropgroups).sort().forEach((cropgroup) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.classList.add('genus-filter-btn');
    btn.textContent = cropgroup;
    btn.dataset.cropgroup = cropgroup;
    btn.addEventListener('click', () => {
      if (activeFilter === cropgroup) {
        clearFilter();
      } else {
        applyFilter(cropgroup);
      }
    });
    filterEl.appendChild(btn);
  });

  const filterContainer = document.getElementById('genus-filter') || genusListEl.parentElement;
  filterContainer.appendChild(filterEl);
  filterContainer.appendChild(clearBtn);
  genusListEl.after(noResultsEl);

  // Restore saved filter on page load — always apply, even if this letter has no matches
  if (saved) {
    applyFilter(saved);
  }
})();